import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { TaskWorkflowByProfile } from "../../core/model/task-workflow-by-profile";
import { Affectation } from "../../core/model/affectation";
import { AffectationService } from "../../core/service/affectation.service";
import { TaskWorkflowByProfileService } from "../../core/service/task-workflow-by-profile.service";

@Component({
  selector: "app-add-affectation",
  templateUrl: "./add-affectation.component.html",
  styleUrls: ["./add-affectation.component.scss"],
})
export class AddAffectationComponent implements OnInit {
  @Input() taskId;
  task: TaskWorkflowByProfile;

  affectation: Affectation = new Affectation();

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _affectationService: AffectationService,
    private _taskWorkflowByProfileService: TaskWorkflowByProfileService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      profileCode: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getTask(this.taskId);
  }

  getTask(taskId) {
    this._taskWorkflowByProfileService
      .getTaskWorkflowByProfileById(taskId)
      .subscribe(
        (data) => {
          this.task = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  save(): void {
    this.affectation.taskWorkflowByProfile = this.task;

    this.pressButton = true;
    this._affectationService
      .add(this.affectation)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
